

const ProfileContainer = ({ children }) => {
    return (
        <div className="bg-white p-6 drop-shadow-md rounded2xl">
            {children}
        </div>
    )
}

export default ProfileContainer;
